<app-draggable-modal-wrapper>
    <h2
        mat-dialog-title
        modal-drag-handle
        class="!text-2xl !font-normal !text-primary-700 !mb-2"
    >
        Emission Designators
        <span class="font-bold">{{ getFrequencyTitle() }}</span>
    </h2>
    <hr />
    <mat-dialog-content class="mat-typography">
        <form [formGroup]="form" class="flex flex-col">
            <div class="grid grid-cols-2 gap-8">
                <div>
                    <div>
                        <h3 class="text-sm !mb-0">
                            Added Emission Designator(s)
                        </h3>
                        <p class="text-xs !mb-0">
                            Click the X to delete an existing emission
                            designator
                        </p>
                    </div>
                    <div class="mt-5">
                        <div
                            class="flex flex-wrap gap-2 overflow-y-auto max-h-44"
                            tabindex="-1"
                        >
                            @for (
                                emissionDesignator of existingEmissionDesignators;
                                track emissionDesignator
                            ) {
                                @if (emissionDesignator.actionCode === null) {
                                    <mat-chip-row
                                        tertiary
                                        (removed)="
                                            onDeleteEmissionDesignatorWithCode(
                                                emissionDesignator.code!
                                            )
                                        "
                                        class="rounded-none text-tertiary-900"
                                    >
                                        <span class="font-mono font-semibold">{{
                                            emissionDesignator.code
                                        }}</span>
                                        <button
                                            type="button"
                                            matChipRemove
                                            aria-label="Remove added emission designator"
                                        >
                                            <mat-icon>cancel</mat-icon>
                                        </button>
                                    </mat-chip-row>
                                }
                            }
                        </div>
                    </div>

                    <div class="mt-5">
                        <h3 class="text-sm">Add Emission Designator(s)</h3>
                        <mat-form-field class="w-full">
                            <input
                                title="Add Emission Designator(s)"
                                placeholder="Add Emission Designator"
                                [formControl]="addEmissionDesignatorFormControl"
                                matInput
                                [matAutocomplete]="addAutocomplete"
                                [maxlength]="
                                    emissionDesignatorConstants.MAXIMUM_EMISSION_DESIGNATOR_LENGTH
                                "
                                [minLength]="
                                    emissionDesignatorConstants.MINIMUM_EMISSION_DESIGNATOR_LENGTH
                                "
                                [appRegexInput]="patterns.Alphanumeric"
                            />
                            <mat-autocomplete
                                autoActiveFirstOption
                                (optionSelected)="
                                    onAddEmissionDesignator($event)
                                "
                                #addAutocomplete="matAutocomplete"
                                [hideSingleSelectionIndicator]="true"
                            >
                                @for (
                                    emissionDesignator of autoCompleteFilteredAddEmissionDesignatorOptions;
                                    track emissionDesignator.value
                                ) {
                                    <mat-option
                                        [value]="emissionDesignator.value"
                                        >{{
                                            emissionDesignator.value
                                        }}</mat-option
                                    >
                                }
                                @if (
                                    shouldShowManualEmissionDesignatorOption()
                                ) {
                                    <mat-option
                                        [value]="
                                            form.controls.addEmissionDesignator
                                                .value
                                        "
                                        >{{
                                            form.controls.addEmissionDesignator
                                                .value
                                        }}
                                        (Manual)</mat-option
                                    >
                                }
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                    <div class="">
                        <div
                            class="flex flex-wrap gap-2 overflow-y-auto max-h-44"
                            tabindex="-1"
                        >
                            @for (
                                addedEmissionDesignator of addedEmissionDesignators;
                                track addedEmissionDesignator
                            ) {
                                @if (
                                    addedEmissionDesignator.actionCode ===
                                    actionCode.Add
                                ) {
                                    <mat-chip-row
                                        primary
                                        (removed)="
                                            onRemoveAddedEmissionDesignator(
                                                addedEmissionDesignator.code!
                                            )
                                        "
                                        class="rounded-none bg-primary-100 text-tertiary-900"
                                    >
                                        <span class="font-mono font-semibold">{{
                                            addedEmissionDesignator.code
                                        }}</span>
                                        <button
                                            type="button"
                                            matChipRemove
                                            aria-label="Remove added emission designator"
                                        >
                                            <mat-icon>cancel</mat-icon>
                                        </button>
                                    </mat-chip-row>
                                }
                            }
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <h3 class="text-sm">Delete Emission Designator(s)</h3>
                        <mat-form-field class="w-full">
                            <input
                                title="Delete Emission Designator(s)"
                                placeholder="Identify Emission Designator to Delete"
                                [formControl]="
                                    deleteEmissionDesignatorFormControl
                                "
                                matInput
                                [matAutocomplete]="deleteAutocomplete"
                                [maxlength]="
                                    emissionDesignatorConstants.MAXIMUM_EMISSION_DESIGNATOR_LENGTH
                                "
                                [appRegexInput]="patterns.Alphanumeric"
                            />
                            <mat-autocomplete
                                autoActiveFirstOption
                                (optionSelected)="
                                    onDeleteEmissionDesignator($event)
                                "
                                #deleteAutocomplete="matAutocomplete"
                                [hideSingleSelectionIndicator]="true"
                            >
                                @for (
                                    emissionDesignator of autoCompleteFilteredDeleteEmissionDesignatorOptions;
                                    track emissionDesignator.value
                                ) {
                                    <mat-option
                                        [value]="emissionDesignator.value"
                                        >{{
                                            emissionDesignator.value
                                        }}</mat-option
                                    >
                                }
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                    <div>
                        <div
                            class="flex flex-wrap gap-2 overflow-y-auto max-h-80"
                            tabindex="-1"
                        >
                            @for (
                                deletedEmissionDesignator of deletedEmissionDesignators;
                                track deletedEmissionDesignator
                            ) {
                                <mat-chip-row
                                    error
                                    (removed)="
                                        onRemoveDeletedEmissionDesignator(
                                            deletedEmissionDesignator.code!
                                        )
                                    "
                                    class="rounded-none bg-primary-100 text-tertiary-900"
                                >
                                    <span class="font-mono">{{
                                        deletedEmissionDesignator.code
                                    }}</span>
                                    <button
                                        type="button"
                                        matChipRemove
                                        aria-label="Remove deleted emission designator"
                                    >
                                        <mat-icon>cancel</mat-icon>
                                    </button>
                                </mat-chip-row>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="!p-5">
        <button
            type="button"
            mat-stroked-button
            mat-dialog-close
            (click)="onCancel()"
            color="primary"
            class="!border-primary-700"
        >
            Cancel
        </button>
        <button
            mat-raised-button
            mat-dialog-close
            type="button"
            (click)="onSave()"
            name="Save"
            cdkFocusInitial
            color="primary"
        >
            Save and Close
        </button>
    </mat-dialog-actions>
</app-draggable-modal-wrapper>
